module.exports = __webpack_public_path__ + "img/sergeantTroop.545d9c11.png";